import React, { useState } from 'react'
import styled from 'styled-components'
import { OptionWrapper } from 'src/editor/layout/sidebar/settings/option-wrapper'

const StringUi = styled.div`
  font-size: 14px;
  font-style: italic;
`

const Icon = styled.i<{ highlighted: boolean }>`
  cursor: pointer;
  margin-left: 10px;
  transition: all 0.1s linear;
  &:hover {
    transform: scale(1.2);
  }
  color: ${p => (p.highlighted ? 'var(--default-blue-color)' : 'inherited')};
`

interface StringProps {
  value: string
  labelText?: string
  helpMessage?: string
}

const String = ({ value, labelText = '', helpMessage = '' }: StringProps) => {
  const [highlighted, setHighlighted] = useState(false)

  async function copyTextToClipboard(text: string) {
    setHighlighted(true)
    await navigator.clipboard.writeText(text)
  }

  return (
    <OptionWrapper labelText={labelText} helpMessage={helpMessage}>
      <StringUi>
        {value}{' '}
        <Icon
          className="far fa-copy"
          highlighted={highlighted}
          onClick={() => copyTextToClipboard(value)}
        />
      </StringUi>
    </OptionWrapper>
  )
}

export default String
